import {
  SET_USER_KYC_LIST,
  SET_USER_KYC_LIST_META,
  SET_LOADING,
} from "./types";
import { KycService } from "../../services/KycService";

/**
 * @author Vikrant.
 * @since 03-05-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
  type: SET_LOADING,
  payload: data,
});
/**
 * @author Vikrant.
 * @since 03-05-2024.
 * @description to set User KYC list
 */
export const setUserKycList = (data) => ({
  type: SET_USER_KYC_LIST,
  payload: data,
});
/**
 * @author Vikrant.
 * @since 03-05-2024.
 * @description to set User KYC list meta
 */
export const setUserKycListMeta = (data) => ({
  type: SET_USER_KYC_LIST_META,
  payload: data,
});

/**
 * @author Vikrant.
 * @since 03-05-2024.
 * @description to get User Kyc list
 */
export const getUserKycList =
  (params, successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await KycService.getUserKyc(params)
      .then(async (res) => {
        await dispatch(setUserKycList(res?.data[0]));
        await dispatch(setUserKycListMeta(res?.metadata));
        successCallback?.();
      })
      .catch(async (err) => {
        console.log("User KYC list Error: ", err);
        errorCallback?.(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Vikrant.
 * @since 02-01-2024.
 * @description to aprove and reject kyc
 */
export const kycConfirmation =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await KycService.kycConfirmation(params)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in make showcase: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

/**
 * @author Vikrant.
 * @since 27-08-2024.
 * @description to aprove without kyc
 */
export const kycConfirmationMark =
  (params, successCallback, errorCallback) => async (dispatch) => {
    // await dispatch(setLoading(true));
    await KycService.kycConfirmationMark(params)
      .then(async (res) => {
        console.log("Result: ", res);
        successCallback(res);
      })
      .catch(async (err) => {
        console.log("Error in make showcase: ", err);
        errorCallback(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
